import React from "react";

import { GroupedFailures } from "../useImportOrdersForm";
import { BuzzOrderValidationFailedSummary } from "./failed-summary/BuzzOrderValidationFailedSummary";
import { ProjectedOrderItem } from "./success-summary/BuzzOrderProjectedOrderItem";
import { BuzzOrderProjectedOrders } from "./success-summary/BuzzOrderProjectedOrders";

interface BuzzOrderValidationSummaryProps {
    groupedCloudOrdersFailures: GroupedFailures[];
    projectedCloudOrders: ProjectedOrderItem[];
    columnsFailures: string[];
    fileMetadataFailures: string[];
    isFileValid: boolean;
    isFileValidated: boolean;
}

export const BuzzOrderValidationSummary: React.FC<BuzzOrderValidationSummaryProps> = ({
    groupedCloudOrdersFailures,
    projectedCloudOrders,
    columnsFailures,
    fileMetadataFailures,
    isFileValid,
    isFileValidated
}: BuzzOrderValidationSummaryProps) => {
    if (isFileValid) {
        return <BuzzOrderProjectedOrders projectedCloudOrders={projectedCloudOrders} />;
    }

    if (isFileValidated) {
        return (
            <BuzzOrderValidationFailedSummary
                groupedCloudOrdersFailures={groupedCloudOrdersFailures}
                columnsFailures={columnsFailures}
                fileMetadataFailures={fileMetadataFailures}
            />
        );
    }

    return null;
};
